/* HomeBarRenderer.js */

"use strict";
const _ = require("lodash");
const SteveCore = require("@gluenetworks/steve_core");
const SolutionsSwitcher = require("../SolutionsSwitcher/SolutionsSwitcherComponent");
const PopUpDisplayComponent = require("./pop_up/PopUpDisplayComponent");
const PopUpWidget = require("@gluenetworks/steve_ui_widgets").PopUp;
const EventRequester = require("@gluenetworks/steve_utilities").EventRequester;
const ComboBoxControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .ComboBox;
const {mountGenAiChat, unmountGenAiChat} = require("@gluenetworks/genai-kendo-chat/legacy-adapter");
// const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
//const IconControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.Icon.SelectList;
let Steve = undefined;

const Sortable = require("sortablejs").default;

class HomeBarRenderer {
    constructor(model) {
        Steve = window.steve || SteveCore;
        this._model = model;
        this._rootElem = document.createElement("home-bar-gl");
        this._rootElem.component = this._model;
        this._rootElem.tabIndex = -1;
        this._xDomeBasedNavItem = [];
        this._onShown(this._model.shown);

        this._steveRouter = undefined;

        if (Steve.router) {
            this._steveRouter = Steve.router;
        } else {
            const steve = Steve.getInstance();
            this._steveRouter = steve._router;
        }

        this._title = document.createElement("h1");
        this._titleLink = document.createElement("span");
        this._titleIcon = document.createElement("actionable-icon-gl");
        this._titleIcon.dataset.icon = "branding.control";
        this._titleIcon.classList.add("title-icon");
        this._title.appendChild(this._titleIcon);
        this._title.appendChild(this._titleLink);

        this._organizationDropdown = new ComboBoxControl({
            placeholder: "Organizations",
            darkTheme: true,
            trimOnSearch: "&nbsp;",
            mobileEnabled: true,
            customObject: true,
        });

        this._aiButton = document.createElement("actionable-icon-gl");
        this._aiButton.classList.add("genAi-icon");
        this._aiButton.dataset.dark = true;
        this._aiButton.dataset.icon = "genAi.solution";
        this._aiButton.classList.add("hidden");

        this._aiButtonDisabled = document.createElement("actionable-icon-gl");
        this._aiButtonDisabled.classList.add("genAi-icon");
        this._aiButtonDisabled.classList.add("hidden");
        this._aiButtonDisabled.dataset.dark = true;
        this._aiButtonDisabled.dataset.icon = "genAi.solution.disabled";
        this._aiButtonDisabled.setAttribute("title", "Gluware Titan Co-Pilot is disabled");
        const aiButtonContainer = document.createElement("div");
        aiButtonContainer.classList.add("ai-button-container");
        aiButtonContainer.appendChild(this._aiButton);
        aiButtonContainer.appendChild(this._aiButtonDisabled);

        this._helpButton = document.createElement("g-icon-gl");
        // this._helpButton.dataset.icon = "common.unknown";
        this._helpButton.setAttribute("title", "Help");
        this._helpButton.classList.add("help-button");
        this._helpButton.classList.add("g-icon-help");

        this._rightButtonsContainer = document.createElement("div");
        this._rightButtonsContainer.classList.add("right-buttons-container-gl");
        this._organization = document.createElement("organization-container-gl");
        this._organization.classList.add("organization-container");
        this._organizationLabel = document.createElement("organization-label-gl");
        this._organizationLabel.classList.add("organization-label");
        this._organizationSeparator = document.createElement("organization-separator-gl");
        this._organizationSeparator.classList.add("organization-separator");
        //this._organization.appendChild(this._organizationLabel);

        this._organization.appendChild(this._organizationDropdown.renderer.rootElement);
        this._organizationDropdown.renderer.rootElement.setAttribute("title", "Organizations");
        //this._organization.appendChild(this._organizationSeparator);

        this._genAiSeparator = document.createElement("genAi-separator-gl");
        this._genAiSeparator.classList.add("genAi-separator");
        this._genAiSeparator.classList.add("hidden");

        this._organizationSeparatorChar = "|";

        this._avatarIcon = document.createElement("actionable-icon-gl");
        this._avatarIcon.classList.add("avatar-icon");
        this._avatarIcon.dataset.dark = true;
        this._avatarIcon.dataset.icon = "common.avatar";

        this._gridIcon = document.createElement("g-icon-gl");
        this._gridIcon.classList.add("grid-icon");
        this._gridIcon.classList.add("g-icon-solutions");
        // this._gridIcon.dataset.dark = true;
        // this._gridIcon.dataset.icon = 'common.grid';

        this._LicenseRefreshed = false;

        this._popupDisplay = new PopUpDisplayComponent({
            name: this._model.getName(),
            nameArray: this._model.getNameArray(),
            role: this._model.getRole(),
            email: this._model.getEmail(),
            image: this._model.getUserImage(),
            organizations: this._model.getOrganizations(),
            activeOrganization: this._model.getActiveOrganization(),
            projects: this._model.getProjects(),
            activeProject: this._model.getActiveProject(),
            context: this._model,
        });

        this._popUpWidget = new PopUpWidget({
            content: this._popupDisplay.renderer.rootElement,
            anchor: this._avatarIcon,
            anchorPoint: "bottomRight",
            displayDirection: "bottomLeft",
            parent: this._rootElem,
            confirmPopupFunc: (this._onConfirmSolutionSwitchPopup =
                this._onConfirmSolutionSwitchPopup.bind(this)),
        });

        this._appSolutionsSwitcher = new SolutionsSwitcher({
            compactView: true,
            solutionManager: this._model.solutionManager,
        });

        this._popUpGridWidget = new PopUpWidget({
            content: this._appSolutionsSwitcher.renderer.rootElement,
            anchor: this._gridIcon,
            anchorPoint: "bottomRight",
            displayDirection: "bottomLeft",
            parent: this._rootElem,
            confirmPopupFunc: (this._onConfirmSolutionSwitchPopup =
                this._onConfirmSolutionSwitchPopup.bind(this)),
        });

        this._rightButtonsContainer.appendChild(this._organization);
        this._rightButtonsContainer.appendChild(this._organizationSeparator);
        // this._rightButtonsContainer.appendChild(this._helpButton);
        // this._rightButtonsContainer.appendChild(this._gridIcon);
        this._aiContainer = document.createElement("ai-container");
        // this._aiChat = createAiChat();
        this._rightButtonsContainer.appendChild(this._aiContainer);
        this._rightButtonsContainer.appendChild(aiButtonContainer);
        this._rightButtonsContainer.appendChild(this._genAiSeparator);
        this._rightButtonsContainer.appendChild(this._avatarIcon);

        this._title.appendChild(this._rightButtonsContainer);
        this._rootElem.appendChild(this._title);
        this._showDebounceTimeout = undefined;
        this._showDebounceDuration = 333;
        this._autoHideTimeout = undefined;
        this._autoHideDuration = 2000;
        this._mouseInsideContents = false;

        this._solutionsSorted = undefined;
        this._reducedNavPerms = undefined;
        this.verticalMenuContainer = undefined;
        this._secondLevelBackground = undefined;
        this._movinOut = false;
        this._sortOrderTemp = [];
        this.moreLessIcon = undefined;

        this._versionControlNavItem = {};
        this._navTextVersionControlCount = {};

        this._buildVerticalMenu();

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("HideGrid", (this._onHideGrid = this._onHideGrid.bind(this)));
        this._model.on(
            "buildVerticalMenu",
            (this._onBuildVerticalMenu = this._onBuildVerticalMenu.bind(this))
        );
        this._model.addListener("Name", (this._onName = this._onName.bind(this)));
        this._model.addListener("Email", (this._onEmail = this._onEmail.bind(this)));
        this._model.addListener("Role", (this._onRole = this._onRole.bind(this)));
        this._model.addListener("Title", (this._onTitle = this._onTitle.bind(this)));
        this._model.addListener("UserId", (this._onUserId = this._onUserId.bind(this)));
        this._model.addListener("UserImage", (this._onUserImage = this._onUserImage.bind(this)));
        this._model.addListener("Icon", (this._onIcon = this._onIcon.bind(this)));
        this._model.addListener(
            "Organizations",
            (this._onOrganizations = this._onOrganizations.bind(this))
        );
        this._model.addListener(
            "OrganizationsDisabled",
            (this._onOrganizationsDisabled = this._onOrganizationsDisabled.bind(this))
        );
        this._model.addListener("Projects", (this._onProjects = this._onProjects.bind(this)));
        this._model.addListener(
            "ProjectsDisabled",
            (this._onProjectsDisabled = this._onProjectsDisabled.bind(this))
        );
        this._model.addListener(
            "MenuDisabled",
            (this._onMenuDisabled = this._onMenuDisabled.bind(this))
        );
        this._model.addListener(
            "ActiveOrganization",
            (this._onActiveOrganization = this._onActiveOrganization.bind(this))
        );
        this._model.addListener(
            "ActiveProject",
            (this._onActiveProject = this._onActiveProject.bind(this))
        );
        this._model.addListener("Disabled", (this._onDisabled = this._onDisabled.bind(this)));
        this._model.addListener("Shown", (this._onShown = this._onShown.bind(this)));
        this._model.addListener("Focus", (this._onFocus = this._onFocus.bind(this)));
        this._model.addListener("Blur", (this._onBlur = this._onBlur.bind(this)));
        // this._model.addListener("UserDataSet", this._onUserDataSet = this._onUserDataSet.bind(this));
        this._model.addListener(
            "UserAuthorizeActions",
            (this._onUserAuthorizeActions = this._onUserAuthorizeActions.bind(this))
        );

        this._titleIcon.addEventListener(
            "click",
            (this._onTitleIconClick = this._onTitleIconClick.bind(this))
        );
        // this._titleLink.addEventListener('click', this._onTitleLinkClick = this._onTitleLinkClick.bind(this));
        this._popupDisplay.addListener(
            "OrganizationChange",
            (this._onPopupDisplayOrganizationChange =
                this._onPopupDisplayOrganizationChange.bind(this))
        );
        this._popupDisplay.addListener(
            "ProjectChange",
            (this._onPopupDisplayProjectChange = this._onPopupDisplayProjectChange.bind(this))
        );
        this._popupDisplay.addListener(
            "HelpSelected",
            (this._onPopupDisplayHelpSelected = this._onPopupDisplayHelpSelected.bind(this))
        );
        this._popupDisplay.addListener(
            "MenuSelected",
            (this._onPopupDisplayMenuSelected = this._onPopupDisplayMenuSelected.bind(this))
        );
        this._popupDisplay.addListener(
            "LogOutSelected",
            (this._onPopupDisplayLogOutSelected = this._onPopupDisplayLogOutSelected.bind(this))
        );
        this._popupDisplay.addListener(
            "editProfileClicked",
            (this._onEditProfileClick = this._onEditProfileClick.bind(this))
        );
        this._popUpGridWidget.addListener(
            "PopUpVisible",
            (this._onPopUpVisible = this._onPopUpVisible.bind(this))
        );
        this._popUpGridWidget.addListener(
            "PopUpHidden",
            (this._onPopUpHidden = this._onPopUpHidden.bind(this))
        );
        this._rootElem.addEventListener(
            "focus",
            (this._onFocusEvent = this._onFocusEvent.bind(this))
        );
        this._rootElem.addEventListener("blur", (this._onBlurEvent = this._onBlurEvent.bind(this)));
        this._appSolutionsSwitcher.addListener(
            "hrefClicked",
            (this._onHrefClicked = this._onHrefClicked.bind(this))
        );
        this._organizationDropdown.addListener(
            "UserValue",
            (this._onOrganizationDropdownUserChange =
                this._onOrganizationDropdownUserChange.bind(this))
        );
        this._helpButton.addEventListener(
            "click",
            (this._onHelpButtonUserClick = this._onHelpButtonUserClick.bind(this))
        );
        this._organizationDropdown.addListener(
            "FilterOptionsDisplayed",
            (this._onFilterOptionsDisplayed = this._onFilterOptionsDisplayed.bind(this))
        );
        // TODO: FORCING INTO CONSTANT OPEN STATE FOR 3.0 RELEASE
        // this._rootElem.addEventListener('mouseenter', this._onMouseEnterEvent = this._onMouseEnterEvent.bind(this));
        // this._rootElem.addEventListener('mouseleave', this._onMouseLeaveEvent = this._onMouseLeaveEvent.bind(this));

        document.addEventListener(
            "click",
            (this._onDocumentClickListener = this._onDocumentClickListener.bind(this))
        );
        this._model.on(
            "routeChanged",
            (this._onRouteInfoChanged = this._onRouteInfoChanged.bind(this))
        );
        this._model.on("refresh", (this._onLicenseRefresh = this._onLicenseRefresh.bind(this)));

        this._model.on(
            "onToggleHideFirstLevel",
            (this._onToggleHideFirstLevel = this._onToggleHideFirstLevel.bind(this))
        );
        this._model.on("onToggleTheme", (this._onToggleTheme = this._onToggleTheme.bind(this)));
        this._model.on(
            "onShowUnlicensed",
            (this._onShowUnlicensed = this._onShowUnlicensed.bind(this))
        );
        this._model.on("AIChat", (this._onSetAIChat = this._onSetAIChat.bind(this)));
        this._aiButton.addEventListener(
            "click",
            (this._onAiButtonClick = this._onAiButtonClick.bind(this))
        );
        this._model.on("CloseChat", (this._onCloseChat = this._onCloseChat.bind(this)));

        this._model.on(
            "GenAiVisibleAndEnable",
            (this._onGenAiVisibleAndEnable = this._onGenAiVisibleAndEnable.bind(this))
        );
        this._model.on(
            "VersionControlCount",
            (this._onVersionControlCountUpdate = this._onVersionControlCountUpdate.bind(this))
        );
        this._model.on(
            "ShowVersionControl",
            (this._onShowVersionControl = this._onShowVersionControl.bind(this))
        );

        this._model.on(
            "ShowItemsBasedOnXDome",
            (this._onShowItemsBasedOnXDome = this._onShowItemsBasedOnXDome.bind(this))
        );
    }

    _unregisterListeners() {
        this._closeAiChat();
        this._model.removeListener("AIChat", this._onSetAIChat);
        this._model.removeListener("CloseChat", this._onCloseChat);
        this._model.removeListener("DisableChatIcon", this._onDisableChatIcon);
        this._model.removeListener("EnableChatIcon", this._onEnableChatIcon);
        this._aiButton.removeListener("click", this._onAiButtonClick);
        this._model.removeListener("HideGrid", this._onHideGrid);
        this._model.removeListener("Name", this._onName);
        this._model.removeListener("Email", this._onEmail);
        this._model.removeListener("UserId", this._onUserId);
        this._model.removeListener("Role", this._onRole);
        this._model.removeListener("Title", this._onTitle);
        this._model.removeListener("Icon", this._onIcon);
        this._model.removeListener("Organizations", this._onOrganizations);
        this._model.removeListener("OrganizationsDisabled", this._onOrganizationsDisabled);
        this._model.removeListener("Projects", this._onProjects);
        this._model.removeListener("ProjectsDisabled", this._onProjectsDisabled);
        this._model.removeListener("MenuDisabled", this._onMenuDisabled);
        this._model.removeListener("ActiveOrganization", this._onActiveOrganization);
        this._model.removeListener("Disabled", this._onDisabled);
        this._model.removeListener("Shown", this._onShown);
        this._model.removeListener("Focus", this._onFocus);
        this._model.removeListener("Blur", this._onBlur);
        // this._model.removeListener("UserDataSet", this._onUserDataSet);
        this._model.removeListener("UserAuthorizeActions", this._onUserAuthorizeActions);

        this._titleIcon.removeEventListener("click", this._onTitleIconClick);
        // this._titleLink.removeEventListener('click', this._onTitleLinkClick);
        this._popupDisplay.removeListener(
            "OrganizationChange",
            this._onPopupDisplayOrganizationChange
        );
        this._popupDisplay.removeListener("ProjectChange", this._onPopupDisplayProjectChange);
        this._popupDisplay.removeListener("HelpSelected", this._onPopupDisplayHelpSelected);
        this._popupDisplay.removeListener("MenuSelected", this._onPopupDisplayMenuSelected);
        this._popupDisplay.removeListener("LogOutSelected", this._onPopupDisplayLogOutSelected);
        this._popupDisplay.removeListener("editProfileClicked", this._onEditProfileClick);
        this._popUpGridWidget.removeListener("PopUpVisible", this._onPopUpVisible);
        this._popUpGridWidget.removeListener("PopUpHidden", this._onPopUpHidden);
        this._rootElem.removeEventListener("focus", this._onFocusEvent);
        this._rootElem.removeEventListener("blur", this._onBlurEvent);
        this._appSolutionsSwitcher.removeListener("hrefClicked", this._onHrefClicked);
        this._organizationDropdown.removeListener(
            "UserValue",
            this._onOrganizationDropdownUserChange
        );
        this._helpButton.removeEventListener("click", this._onHelpButtonUserClick);
        this._organizationDropdown.removeListener(
            "FilterOptionsDisplayed",
            this._onFilterOptionsDisplayed
        );
        // TODO: FORCING INTO CONSTANT OPEN STATE FOR 3.0 RELEASE
        //this._rootElem.removeEventListener('mouseenter', this._onMouseEnterEvent);
        //this._rootElem.removeEventListener('mouseleave', this._onMouseLeaveEvent);
        this._model.removeEventListener("buildVerticalMenu", this._onBuildVerticalMenu);
        document.removeEventListener("click", this._onDocumentClickListener);
        this._model.removeListener("routeChanged", this._onRouteInfoChanged);
        this._model.removeListener("refresh", this._onLicenseRefresh);
        this._model.removeListener("_onToggleHideFirstLevel", this._onToggleHideFirstLevel);
        this._model.removeListener("GenAiVisibleAndEnable", this._onGenAiVisibleAndEnable);
        this._model.removeListener("VersionControlCount", this._onVersionControlCountUpdate);
        this._model.removeListener("ShowVersionControl", this._onShowVersionControl);
        this._model.removeListener("ShowItemsBasedOnXDome", this._onShowItemsBasedOnXDome);
    }

    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._title = undefined;
            this._titleLink = undefined;
            this._titleIcon = undefined;
            this._avatarIcon = undefined;
            this._helpButton = undefined;
            this._popupDisplay.shutdown().then(() => {
                this._popupDisplay = undefined;
            });
            this._popUpWidget.shutdown().then(() => {
                this._popUpWidget = undefined;
            });
            if (!_.isUndefined(this._autoHideTimeout)) {
                clearTimeout(this._autoHideTimeout);
            }
            this._autoHideTimeout = undefined;
            this._autoHideDuration = undefined;
            if (!_.isUndefined(this._showDebounceTimeout)) {
                clearTimeout(this._showDebounceTimeout);
            }
            this._showDebounceTimeout = undefined;
            this._showDebounceDuration = undefined;

            this._solutionsSorted = undefined;
            this._movinOut = undefined;

            this._secondLevelBackground = undefined;

            this._sortOrderTemp = [];
            this.moreLessIcon = undefined;
            this._LicenseRefreshed = undefined;
            this._versionControlNavItem = undefined;
            this._navTextVersionControlCount = undefined;
            this._xDomeBasedNavItem = undefined;
            this._reducedNavPerms = undefined;

            resolve();
        });
        return prom;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setName(this._model.getName());
            this._setTitle(this._model.getTitle());
            this._setIcon(this._model.getIcon());
            this._setImage(this._model.getUserImage());
            this._setIconNotActionable(this._model.getIconNotActionable());
            this._setEmail(this._model.getEmail());
            this._setOrganizationsDisabled(this._model.getRole());
            this._setOrganizations(this._model.getOrganizations());
            this._setOrganizationsDisabled(this._model.getOrganizationsDisabled());
            this._setProjects(this._model.getProjects());
            this._setProjectsDisabled(this._model.getProjectsDisabled());
            this._setMenuDisabled(this._model.getMenuDisabled());
            this._setActiveOrganization(this._model.getActiveOrganization());
            this._setDisabled(this._model.getDisabled());
            // TODO: FORCING INTO CONSTANT OPEN STATE FOR 3.0 RELEASE

            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSetAIChat() {
        this._setAIChat();
    }

    _onUserImage(newVal) {
        this._setImage(newVal);
    }
    /**
     * Fired when org dropdown options are displayed
     */
    _onFilterOptionsDisplayed(optionsContainer) {
        optionsContainer.style.height = `${window.innerHeight / 2}px`;
    }

    /**
     * Fired when the user's name has been updated in the model
     * @param newVal {object}
     * @private
     */
    _onName(newVal, arr) {
        this._setName(newVal, arr);
    }

    /**
     * Fired when the title has been updated in the model
     * @param newVal {string}
     * @private
     */
    _onTitle(newVal) {
        this._setTitle(newVal);
    }

    _onUserId(newVal) {
        this._setUserId(newVal);
    }

    /**
     * Fired when the icon has been updated in the model
     * @param newVal {string}
     * @private
     */
    _onIcon(newVal) {
        this._setIcon(newVal);
    }

    /**
     * Fired when the user's email address has been updated in the model
     * @param newVal {array}
     * @private
     */
    _onEmail(newVal) {
        this._setEmail(newVal);
    }

    _onRole(newVal) {
        this._setRole(newVal);
    }

    /**
     * Fired when the organizations have been updated in the model
     * @param newVal {object}
     * @private
     */
    _onOrganizations(newVal) {
        this._setOrganizations(newVal);
    }

    _onProjects(newVal) {
        this._setProjects(newVal);
    }

    /**
     * Fired when the organizations have been disabled/enabled in the model
     * @param newVal {boolean}
     * @private
     */
    _onOrganizationsDisabled(newVal) {
        this._setOrganizationsDisabled(newVal);
    }

    _onProjectsDisabled(newVal) {
        this._setProjectsDisabled(newVal);
    }

    /**
     * Fired when the menu has been disabled/enabled in the model
     * @param newVal {boolean}
     * @private
     */
    _onMenuDisabled(newVal) {
        this._setMenuDisabled(newVal);
    }

    /**
     * Fired when the active organization have been updated in the model
     * @param newVal {object}
     * @private
     */
    _onActiveOrganization(newVal) {
        this._setActiveOrganization(newVal);

        this._setTitle(this._model.getTitle());
    }

    _onActiveProject(newVal) {
        this._setActiveProject(newVal);
    }

    /**
     * Fired when the user has selected a new org from the org dropdown
     * @param newVal {object|array|boolean|number|string}
     * @param oldVal {object|array|boolean|number|string}
     * @param event {event}
     * @private
     */
    _onOrganizationDropdownUserChange(newVal, oldVal, event) {
        this._model._controlUserEntity.setProperty("lastTenantId", _.get(newVal, "id", ""));
        this._model._controlUserEntity.update();
        this._model._triggerOrganizationChange(newVal, oldVal, event);
    }

    /**
     * Fired when the disabled state has been toggled in the model
     * @param newVal {boolean}
     * @private
     */
    _onDisabled(newVal) {
        this._setDisabled(newVal);
    }

    /**
     * Fired when shown state has been toggled in the model
     * @param newVal {boolean}
     * @private
     */
    _onShown(newVal) {
        if (newVal) {
            this._rootElem.classList.add("shown");
        } else {
            this._rootElem.classList.remove("shown");
            this._hidePopupWidgets();
        }
    }

    /**
     * Fired when an href is clicked in the ASS
     * @private
     */
    _onHrefClicked() {
        if (this._popUpGridWidget) {
            this._popUpGridWidget.hide();
        }
    }

    /**
     * Fired when the user has clicked the help button
     * @param event {event}
     * @private
     */
    _onHelpButtonUserClick(event) {
        this._model._triggerHelpSelected(event);
    }

    /**
     * Fired when focus has been called in the model
     * @private
     */
    _onFocus() {
        this._setFocus(true);
    }

    /**
     * Fired when blur has been called in the model
     * @private
     */
    _onBlur() {
        this._setFocus(false);
    }

    /**
     * Fired when userDataSet has been called in the model
     * @private
     */
    _onUserDataSet() {
        this._appSolutionsSwitcher.setUserData(this._model._userData);
    }

    /**
     * Fired when userAuthorizedActions has been called in the model
     * @private
     */
    _onUserAuthorizeActions() {
        // Update permissions data and refresh the second-level nav items
        this._updateSecondLevelNavPermissions();
    }

    _updateSecondLevelNavPermissions() {
        const container = this.verticalMenuContainer;
        if (container && container.children && this._solutionsSorted) {
            const subNavItems = container.querySelectorAll(".glu-sub-nav__item");

            // Reduce navOptions permission list
            this._reducedNavPerms = this._solutionsSorted.reduce((acc, solution) => {
                const navOptions = solution.registeredObj.navOptions || {};
                Object.entries(navOptions).forEach(([key, value]) => {
                    if (value.perms && value.perms.length > 0) {
                        acc[key] = value.perms;
                    }
                });
                return acc;
            }, {});

            subNavItems.forEach((el) => {
                this._updateSecondLevelNavItem(el);
            });
        }
    }

    _updateSecondLevelNavItem(el) {
        const itemName = el.getAttribute("item");

        if (itemName && this._isSubNavItemEnabled(itemName)) {
            el.setAttribute("name", itemName);
        } else {
            el.setAttribute("name", "disabled");
        }
    }

    _isSubNavItemEnabled(itemName) {
        const userAuthorizedActions = this.model._userAuthorizedActions || [];
        if (this._reducedNavPerms[itemName]) {
            const matchedPerms = this._reducedNavPerms[itemName].reduce(
                (acc, currentPerm) =>
                    userAuthorizedActions.indexOf(currentPerm) > -1 ? acc + 1 : acc,
                0
            );
            if (userAuthorizedActions && this._reducedNavPerms[itemName].length > matchedPerms) {
                return false;
            }
        }
        return true;
    }

    /**
     * Fired when the title icon has been clicked
     * @param event {event}
     * @private
     */
    async _onTitleIconClick(event) {
        // jshint ignore:line
        let proceed = true;
        if (EventRequester && EventRequester.singleton) {
            // request to continue action
            proceed = await EventRequester.singleton.requestViewChange(); // jshint ignore:line
        }
        if (proceed) {
            this._model._triggerTitleSelected(event);
        }
    }

    /**
     * Fired when the title text has been clicked
     * @param event {event}
     * @private
     */
    async _onTitleLinkClick(event) {
        // jshint ignore:line
        let proceed = true;
        if (EventRequester && EventRequester.singleton) {
            // request to continue action
            proceed = await EventRequester.singleton.requestViewChange(); // jshint ignore:line
        }
        if (proceed) {
            this._model._triggerTitleSelected(event);
        }
    }

    /**
     * Fired when the user has changed on organization
     * @param newOrganization {object|array|boolean|number|string}
     * @param oldOrganization {object|array|boolean|number|string}
     * @param event {event}
     * @private
     */
    _onPopupDisplayOrganizationChange(newOrganization, oldOrganization, event) {
        this._model._triggerOrganizationChange(newOrganization, oldOrganization, event);
    }

    _onPopupDisplayProjectChange(newProject, oldProject, event) {
        this._model._triggerProjectChange(newProject, oldProject, event);
    }

    /**
     * Fired when the user has clicked on the help button
     * @param event {event}
     * @private
     */
    _onPopupDisplayHelpSelected(event) {
        this._model._triggerHelpSelected(event);
    }

    /**
     * Fired when the user has clicked on the menu button
     * @param event {event}
     * @private
     */
    _onPopupDisplayMenuSelected(event) {
        this._model._triggerMenuSelected(event);
    }

    /**
     * Fired when the user has clicked on the log out button
     * @param event {event}
     * @private
     */
    _onPopupDisplayLogOutSelected(event) {
        this._model._triggerLogOutSelected(event);
    }

    /**
     * Fired when the solutions popup opens and closes
     * @param event {event}
     * @private
     */
    _onPopUpVisible() {
        this._gridIcon.classList.add("active");
    }
    _onPopUpHidden() {
        this._gridIcon.classList.remove("active");
    }

    /**
     * Pass the focus event up to the model
     * @param event {Event}
     * @private
     */
    _onFocusEvent(/*event*/) {
        //this._model._triggerUserFocus(event);
    }

    /**
     * Pass the blur event up to the model
     * @param event {Event}
     * @private
     */
    _onBlurEvent(/*event*/) {
        //this._model._triggerUserBlur(event);
    }

    /**
     * Pass the blur event up to the model
     * @param event {Event}
     * @private
     */
    _onMouseEnterEvent(event) {
        this._mouseInsideContents = true;
        if (!_.isUndefined(this._showDebounceTimeout)) {
            clearTimeout(this._showDebounceTimeout);
            this._showDebounceTimeout = undefined;
        }
        this._showDebounceTimeout = setTimeout(() => {
            this._showDebounceTimeout = undefined;
            this._model.setShown(true);
            this._model._triggerAutoShow(event);
        }, this._showDebounceDuration);
    }

    /**
     * Pass the blur event up to the model
     * @param event {Event}
     * @private
     */
    _onMouseLeaveEvent(event) {
        this._mouseInsideContents = false;
        if (!_.isUndefined(this._showDebounceTimeout)) {
            clearTimeout(this._showDebounceTimeout);
            this._showDebounceTimeout = undefined;
        }
        this._createHideTimeout(event);
    }

    // eslint-disable-next-line no-unused-vars
    async _onConfirmSolutionSwitchPopup(event) {
        let proceed = true;
        if (EventRequester && EventRequester.singleton) {
            proceed = await EventRequester.singleton.requestViewChange(); // jshint ignore:line
        }
        return proceed;
    }

    _onBuildVerticalMenu() {
        const isClassic =
                _.get(this._model._solutionManager, "_activeSolution.name", "") === "classic",
            isLogin =
                (this._steveRouter.getRouteDetails &&
                    this._steveRouter.getRouteDetails().s === "LoginCenter") ||
                false;
        if (isClassic && !isLogin) {
            const sortOrder = Steve.user
                ? Steve.user.preferences._regStorage.getValue(
                      "common.vertical_navigation.sort_order"
                  )
                : [];
            this._moreLessIndex = Steve.user
                ? Steve.user.preferences._regStorage.getValue(
                      "common.vertical_navigation.more_less_index"
                  )
                : 5;
            if (sortOrder) {
                this._model._sortOrderArray = sortOrder.value ? sortOrder.value : sortOrder;
            }
        } else if (!this._model._userDataStorage) {
            this._model._userDataStorage = this._model._storageFactory.getRemoteStorageInstance(
                "common",
                "vertical_navigation"
            );
            this._model._sortOrderArray = this._model._userDataStorage.getData
                ? this._model._userDataStorage.getData("sort_order", true) || []
                : [];
            this._moreLessIndex = this._model._userDataStorage.getData
                ? this._model._userDataStorage.getData("more_less_index", true) || 5
                : 5;

            if (
                !_.isEmpty(this._model._sortOrderArray) &&
                this._model._sortOrderArray.indexOf("topology") < 0
            ) {
                // const settingsIndex = this._model._sortOrderArray.indexOf("system_settings");
                this._model._sortOrderArray.splice(
                    parseInt(this._moreLessIndex, 10) - 2,
                    0,
                    "topology"
                );
            }

            if (
                !_.isEmpty(this._model._sortOrderArray) &&
                this._model._sortOrderArray.indexOf("rpa") < 0
            ) {
                // const settingsIndex = this._model._sortOrderArray.indexOf("system_settings");
                this._model._sortOrderArray.splice(parseInt(this._moreLessIndex, 10) - 2, 0, "rpa");
            }
        }

        this._moreLessIndex =
            this._moreLessIndex && (this._moreLessIndex.value || this._moreLessIndex.value === 0)
                ? this._moreLessIndex.value
                : this._moreLessIndex || this._moreLessIndex === 0
                ? this._moreLessIndex
                : 5;
        this._buildVerticalMenu();
        this._addClassIfVersionControlCountExists();
    }

    _onNavMoreLessItemHover(e) {
        e.preventDefault();
        if (this.moreLessIcon.classList.contains("more")) {
            this._setMoreOrLess(1);
        }
        // } else if(_.isNull(this.verticalMenuContainer.querySelector(".selected.to-be-hidden"))) {
        //     this._setMoreOrLess(0);
        // }
    }

    _onNavMoreLessItemClick(e) {
        e.preventDefault();
        if (this.moreLessIcon.classList.contains("more")) {
            this._setMoreOrLess(1);
        } else if (_.isNull(this.verticalMenuContainer.querySelector(".selected.to-be-hidden"))) {
            this._setMoreOrLess(0);
        }
    }

    _onHelpIconClick(e) {
        e.preventDefault();
        if (
            e.target.className === "glu-sub-nav__item" ||
            e.target.classList.contains("more-less-icon-inner-container") ||
            e.target.classList.contains("more-less-text") ||
            e.target.classList.contains("more-icon") ||
            e.target.classList.contains("less-more-icon")
        ) {
            return;
        }
        const currentElement = e.currentTarget,
            textElement = currentElement.querySelector(".glu-nav__item-text");

        if (textElement.classList.contains("expanded")) {
            // const url = e.currentTarget.getAttribute("help-link"),
            // isClassic = (_.get(this._model._solutionManager, "_activeSolution.name", "") === "classic");
            // // this._openInNewTab(`${location.origin}/${url}`);
            // if(isClassic) {
            //     this._buildUrl({sln: "RoboHelp", url } );
            // } else {
            //     this._steveRouter.navigateToHelpTab({ app: "GameConsole", s: "RoboHelp", sln: url }, "robohelp");
            // }

            this._model._triggerHelpSelected(e);
        }
    }

    _onVerticalMenuClick(e) {
        e.preventDefault();
        if (
            e.target.classList.contains("more-less-icon-inner-container") ||
            e.target.classList.contains("more-less-text") ||
            e.target.classList.contains("more-icon") ||
            e.target.classList.contains("less-more-icon")
        ) {
            return;
        }
        if (!this._movinOut) {
            this.verticalMenuContainer
                .querySelectorAll(".glu-nav__item-text")
                .forEach((eachItem) => eachItem.classList.add("expanded"));
        }
        this._movinOut = false;
    }

    _onNavItemHover(e) {
        const currentElement = e.currentTarget,
            textElement = currentElement.querySelector(".glu-nav__item-text");

        if (!this._movinOut) {
            this.verticalMenuContainer
                .querySelectorAll(".glu-nav__item-text")
                .forEach((eachItem) => eachItem.classList.add("expanded"));
        }
        this._movinOut = false;

        if (
            textElement.classList.contains("expanded") &&
            !currentElement.getAttribute("disabled")
        ) {
            this.verticalMenuContainer
                .querySelectorAll(".glu-nav__item")
                .forEach((eachMenuItem) => eachMenuItem.classList.remove("hover"));
            currentElement.classList.add("hover");
            const subNav = currentElement.querySelector(".glu-sub-nav");
            if (
                textElement.classList.contains("deep") &&
                !textElement.classList.contains("more-less-text")
            ) {
                this._hideSecondLevel();

                this.verticalMenuContainer.classList.add("noshadow");
                this._secondLevelBackground.classList.add("second-step-bgd--expanded");
                if (subNav) {
                    subNav.classList.add("second-step--expanded");
                }
            } else {
                this._hideSecondLevel();
            }
        }
    }

    _onDocumentClickListener(e) {
        const navigationRef = this.verticalMenuContainer;
        if (
            !navigationRef ||
            navigationRef.contains(e.target) ||
            (e.target.className.includes &&
                e.target.className.includes("glu-navigation-second-step-bgd"))
        ) {
            return;
        }
        // clicked outside component
        this.hideVerticalNavbar();
    }

    _onRouteInfoChanged(newRoute) {
        if (!_.isEmpty(this._solutionsSorted)) {
            const newSolution = this._solutionsSorted.filter(
                (i) => i.registeredDetails.name === (newRoute.sln || newRoute.s)
            );
            if (!_.isEmpty(newSolution)) {
                this.verticalMenuContainer
                    .querySelector(".help-icon")
                    .setAttribute("help-link", newSolution[0].registeredObj.helpLink);
            }
        }
    }

    _onNavItemClick(e) {
        e.preventDefault();
        if (
            e.target.className === "glu-sub-nav__item" ||
            e.target.classList.contains("more-less-icon-inner-container") ||
            e.target.classList.contains("more-less-text") ||
            e.target.classList.contains("more-icon") ||
            e.target.classList.contains("less-more-icon")
        ) {
            return;
        }
        const currentElement = e.currentTarget,
            textElement = currentElement.querySelector(".glu-nav__item-text"),
            isClassic =
                _.get(this._model._solutionManager, "_activeSolution.name", "") === "classic";

        if (
            textElement.classList.contains("expanded") &&
            !currentElement.getAttribute("disabled")
        ) {
            this.verticalMenuContainer.querySelectorAll(".selected").forEach((item) => {
                item.classList.remove("selected");
            });
            currentElement.classList.add("selected");

            this._movinOut = true;
            const selectedSolutionObj = this._solutionsSorted.filter(
                (item) => item.registeredObj.name === currentElement.getAttribute("name")
            )[0];
            this.hideVerticalNavbar();
            const steve2Path =
                selectedSolutionObj.steve2Path || selectedSolutionObj.registeredObj.steve2Path;
            if (!_.isEmpty(steve2Path)) {
                location.href = location.origin + steve2Path;
            } else if (selectedSolutionObj.registeredDetails.name === "rpa") {
                location.href = location.origin + "/frontend/rpa";
            } else if (selectedSolutionObj.registeredDetails.name === "topology") {
                location.href = location.origin + "/frontend/topology";
            } else {
                const routeDetails = {
                    app: selectedSolutionObj.registeredObj.app,
                    s: selectedSolutionObj.registeredObj.section,
                    sln: selectedSolutionObj.registeredDetails.name,
                    rd: null,
                    ra: "",
                };

                if (isClassic) {
                    this._buildUrl(routeDetails);
                    return;
                }

                this._steveRouter.goTo(routeDetails);
            }
        }
    }

    _onSecondLevelItemClick(e) {
        e.preventDefault();

        const parentItem = e.target.closest(".glu-nav__item");
        if (!parentItem) {
            this._logger.warn("Parent item not found");
            return;
        }

        const isClassic =
            _.get(this._model._solutionManager, "_activeSolution.name", "") === "classic";

        this.verticalMenuContainer.querySelectorAll(".selected").forEach((item) => {
            item.classList.remove("selected");
        });
        parentItem.classList.add("selected");

        const currentItemName = e.target.getAttribute("name");
        if (!currentItemName) {
            this._logger.warn("Current item name not found");
            return;
        }
        if (currentItemName === "disabled") {
            return;
        }

        this._movinOut = true;
        const selectedSolutionObj = this._solutionsSorted.find(
            (item) => item.registeredObj.name === parentItem.getAttribute("name")
        );
        if (_.isEmpty(selectedSolutionObj)) {
            this._logger.warn("Selected solution not found");
            return;
        }

        this.hideVerticalNavbar();
        const currentNavOptions = _.get(selectedSolutionObj, [
            "registeredObj",
            "navOptions",
            currentItemName,
        ]);
        if (_.isEmpty(currentNavOptions)) {
            this._logger.warn("Current navigation options not found");
            return;
        }

        if (currentItemName === "running") {
            let currentRunningDashboard;
            if (isClassic) {
                const currentDb = Steve.user.preferences._regStorage.getValue(
                    "dashboards.latest.running"
                );
                if (currentDb) {
                    currentRunningDashboard = currentDb.value ? currentDb.value : currentDb;
                }
            } else {
                currentRunningDashboard = this._model._storageFactory
                    .getRemoteStorageInstance("dashboards", "latest")
                    .getData("running", true);
            }
            const ra = currentNavOptions.options
                    ? `${currentNavOptions.options.ra}/${currentRunningDashboard}`
                    : "",
                options = {
                    app: selectedSolutionObj.registeredObj.app,
                    s: selectedSolutionObj.registeredObj.section,
                    sln: selectedSolutionObj.registeredDetails.name,
                    rd: null,
                    ra,
                };
            if (isClassic) {
                this._buildUrl(options);
                return;
            }
            this._steveRouter.goTo(options);
            return;
        }

        if (currentNavOptions.steve2Path) {
            location.href = location.origin + currentNavOptions.steve2Path;
        } else if (!_.isEmpty(selectedSolutionObj.registeredObj.steve2Path)) {
            if (selectedSolutionObj.registeredObj.navOptions[currentItemName].options) {
                let encodedUrlRd = this._getEncodedRouteData(currentNavOptions.options.rd);
                let url = selectedSolutionObj.registeredObj.steve2Path + encodedUrlRd;
                if (isClassic) {
                    this._redirectFromClassic("Perspective", {
                        routeData: currentNavOptions.options.rd,
                    });
                    return;
                }
                location.href = location.origin + url;
            }
        } else {
            const ra = currentNavOptions.options ? currentNavOptions.options.ra : "";
            if (selectedSolutionObj.registeredDetails.name === "rpa") {
                location.href = location.origin + "/frontend/rpa/" + ra;
            } else if (selectedSolutionObj.registeredDetails.name === "topology") {
                location.href = location.origin + "/frontend/topology/" + ra;
            } else {
                const exp = currentNavOptions.options ? currentNavOptions.options.exp : "";
                const sr = currentNavOptions.options ? currentNavOptions.options.sr : "";
                const routeDetails = {
                    app: selectedSolutionObj.registeredObj.app,
                    s: selectedSolutionObj.registeredObj.section,
                    sln: selectedSolutionObj.registeredDetails.name,
                    rd: null,
                    ra,
                    exp,
                    sr,
                };

                if (isClassic) {
                    this._buildUrl(routeDetails);
                    return;
                }

                this._steveRouter.goTo(routeDetails);
            }
        }
    }

    _redirectFromClassic(section, options) {
        this._steveRouter.goTo(section, options);
    }

    _buildUrl(options) {
        let url = this._model._solutionManager.getSolutionUrl(options.sln);

        if (options.ra) {
            url += `/_ra_/${options.ra}`;
        }
        if (options.exp) {
            url += `/_exp_/${options.exp}`;
        }
        if (options.sr) {
            url += `/_sr_/${options.sr}`;
        }
        if (options.url) {
            url += `/${options.url}`;
        }

        const lastSoln = url.split("#!")[1];
        if (lastSoln !== this._model._controlUserEntity.getProperty("lastRoute")) {
            this._model._controlUserEntity.setProperty("lastRoute", lastSoln);
            this._model._controlUserEntity
                .update()
                .then(() => {
                    window.sessionStorage.setItem(
                        this._model._userData.userId + "lastPathInfo",
                        lastSoln
                    );
                })
                .catch((err) => {
                    this._logger.warn("Unable to save last solution info.", err);
                })
                .finally(() => {
                    location.href = url;
                });
        } else {
            location.href = url;
        }
    }

    _getEncodedRouteData(data) {
        let routeDetails = data;

        if (!data) {
            routeDetails = {
                activeOrganization: this._model.getActiveOrganization(),
            };
        }

        let rdStr = JSON.stringify(routeDetails);
        if (Steve.util) {
            return Steve.util.b64EncodeUnicode(rdStr);
        } else {
            return this._steveRouter.buildHash({rd: routeDetails}).replace("#!/_rd_/", "");
        }
    }

    _onLicenseRefresh() {
        if (this._solutionsSorted) {
            this._solutionsSorted.forEach((solution) => {
                const restricted = this._model.checkIfRestricted(solution.registeredObj);
                if (_.isUndefined(restricted) || restricted) {
                    this.verticalMenuContainer
                        .querySelector("[name=" + solution.registeredObj.name + "]")
                        .setAttribute("disabled", true);
                } else {
                    this.verticalMenuContainer
                        .querySelector("[name=" + solution.registeredObj.name + "]")
                        .removeAttribute("disabled");
                }
            });
            this._model.emit("LicensesSet");
        } else {
            this._LicenseRefreshed = true;
        }
    }

    _onShowUnlicensed(val) {
        this._toggleShowUnlicensed(val);
    }

    _onToggleHideFirstLevel(val) {
        this._toggleHideFirstLevelClass(!val);
    }

    _onGenAiVisibleAndEnable() {
        const {_genAiVisible, _genAiEnabled} = this._model;

        this._genAiSeparator.classList.toggle("hidden", !_genAiVisible);
        this._aiButton.classList.toggle("hidden", !_genAiVisible || !_genAiEnabled);
        this._aiButtonDisabled.classList.toggle("hidden", !_genAiVisible || _genAiEnabled);
    }

    _onVersionControlCountUpdate() {
        this._addClassIfVersionControlCountExists();
    }

    _onShowVersionControl(newVal = false) {
        if (this._versionControlNavItem) {
            this._versionControlNavItem.hidden = !newVal;
        }
    }

    _onShowItemsBasedOnXDome(newVal = false) {
        if (this._xDomeBasedNavItem && this._xDomeBasedNavItem.length > 0) {
            this._xDomeBasedNavItem.forEach((item) => {
                item.hidden = !newVal;
            });
        }
    }

    _onToggleTheme(val) {
        this._toggleTheme(!val);
    }

    _onEditProfileClick() {
        this._popUpWidget.hide();
    }

    _onAiButtonClick() {
        this._openAiChat();
    }
    _onCloseChat() {
        this._closeAiChat();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    // The Kendo chat mounts lazily on first open, so re-announcing the service only drops the current
    // mount; the next open rebuilds it with fresh org/solution/user values.
    _setAIChat() {
        this._closeAiChat();
    }

    _openAiChat() {
        if (this._aiChatRoot) {
            return;
        }
        this._aiChatRoot = mountGenAiChat(this._aiContainer, {
            userId: this._aiUserId(),
            organizationId: this._aiOrganizationId(),
            currentSolutionName: this._aiSolutionName(),
            userAvatar: this._aiUserAvatar(),
            close: () => this._model.closeChatWindow(false, true),
        });
    }

    _closeAiChat() {
        if (!this._aiChatRoot) {
            return;
        }
        const root = this._aiChatRoot;
        this._aiChatRoot = undefined;
        // Close arrives from inside a React event handler; unmounting synchronously would tear the
        // root down mid-render.
        setTimeout(() => unmountGenAiChat(root), 0);
    }

    // Without this the chat cannot key its stored preferences and silently stops persisting them.
    // The two authentication paths hand the home bar different user shapes: a UserEntity (`id`) and
    // the steve2 userInfo (`userId`). Both carry the same platform user id the preferences API wants.
    _aiUserId() {
        const userData = this._model._userData;
        return _.get(userData, "id") || _.get(userData, "userId") || "";
    }

    _aiOrganizationId() {
        return _.get(this._model.getActiveOrganization(), "id", "");
    }

    // The manager exposes the active solution as a getter on newer builds and a plain field on older
    // ones; "device_manager" is the same default the React host falls back to.
    _aiSolutionName() {
        const solutionManager = this._model.solutionManager;
        const activeSolution = _.isFunction(_.get(solutionManager, "getActiveSolution"))
            ? solutionManager.getActiveSolution()
            : _.get(solutionManager, "_activeSolution");
        return _.get(activeSolution, "name") || "device_manager";
    }

    _aiUserAvatar() {
        const nameArr = this._model.getNameArray() || ["", ""];
        const fInitial = nameArr[0] ? nameArr[0].charAt(0).toUpperCase() : "";
        const lInitial = nameArr[1] ? nameArr[1].charAt(0).toUpperCase() : "";
        return {
            fallback: `${fInitial}${lInitial}`,
            displayName: this._model.getName() || "",
            image: this._model.getUserImage() || "",
        };
    }

    _setImage(newVal) {
        this._popupDisplay.setProfileImage(newVal);
        this._setProfileImage(newVal);
    }

    _setProfileImage(src) {
        if (!src) {
            if (this._avatarIcon.querySelectorAll("img").length > 0) {
                this._setName(this._model._name, this._model._nameArr);
            }
            return;
        }
        const _profImage = document.createElement("img");
        _profImage.src = src;
        this._avatarIcon.innerHTML = "";
        this._avatarIcon.appendChild(_profImage);
    }
    /**
     * Update the user's name
     * @param newVal {string}
     * @private
     */
    _setName(newVal, arr) {
        this._popupDisplay.setName(newVal, arr);
        if (arr && !this._model._userImage) {
            this._setInitials(arr);
        }
    }

    _setInitials(nameArr, iconElem) {
        const fInitial = nameArr[0] ? nameArr[0].charAt(0).toUpperCase() : "";
        const lInitial = nameArr[1] ? nameArr[1].charAt(0).toUpperCase() : "";
        if (iconElem) {
            iconElem.innerHTML = fInitial;
        } else {
            this._avatarIcon.innerHTML = fInitial;
        }
        return this._setBackground(fInitial, lInitial, iconElem);
    }

    _setBackground(fInitial, lInitial, iconElem) {
        let fCode = 0,
            lCode = 0;
        if (fInitial) {
            fCode = fInitial.charCodeAt(0);
        }
        if (lInitial) {
            lCode = lInitial.charCodeAt(0);
        }

        const bgNum = ((fCode + lCode) % 14) + 1;
        if (iconElem) {
            iconElem.classList.add("bg-color-grp-" + bgNum);
        } else {
            this._avatarIcon.classList.add("bg-color-grp-" + bgNum);
        }
        return iconElem;
    }

    /**
     * Update the title of the homebar
     * @param newVal {string}
     * @private
     */
    _setTitle(newVal) {
        if (!_.isUndefined(newVal)) {
            this._titleLink.innerHTML = newVal;
        } else {
            this._titleLink.innerHTML = "";
        }
        if (newVal) {
            this._titleLink.classList.add("has-title");
        } else {
            this._titleLink.classList.remove("has-title");
        }
    }

    _setUserId(newVal) {
        this._popupDisplay.setUserId(newVal);
    }

    /**
     * Update the icon in the homebar
     * @param newVal {string}
     * @private
     */
    _setIcon(newVal) {
        return newVal;
    }

    /**
     * Update the icon in the homebar
     * @param newVal {boolean}
     * @private
     */
    _setIconNotActionable(newVal) {
        this._titleIcon.remove();
        let icon = this._titleIcon.dataset.icon;
        if (newVal) {
            this._titleIcon = document.createElement("base-icon-gl");
            this._titleIcon.dataset.icon = icon;
            this._title.classList.add("not-actionable");
        } else {
            this._titleIcon = document.createElement("actionable-icon-gl");
            this._titleIcon.dataset.icon = icon;
            this._titleIcon.addEventListener("click", this._onTitleIconClick);
        }
        this._titleIcon.classList.add("control-icon");

        this._titleIcon.classList.add("title-icon");
        this._title.insertBefore(this._titleIcon, this._titleLink);
    }

    /**
     * Update the user's email
     * @param newVal {string}
     * @private
     */
    _setEmail(newVal) {
        this._popupDisplay.setEmail(newVal);
    }

    _setRole(newVal) {
        this._popupDisplay.setRole(newVal);
    }

    /**
     * Update the organizations
     * @param newVal {array}
     * @private
     */
    _setOrganizations(newVal) {
        //this._popupDisplay.setOrganizations(newVal);
        this._organizationDropdown.setOptions(newVal);
    }

    _setProjects(newVal) {
        this._popupDisplay.setProjects(newVal);
    }

    /**
     * Disable/enable the organizations dropdown in the popup display
     * @param newVal {boolean}
     * @private
     */
    _setOrganizationsDisabled(newVal) {
        //this._popupDisplay.setOrganizationsDisabled(newVal);
        this._organizationDropdown.setDisabled(newVal);
    }

    _setProjectsDisabled(newVal) {
        this._popupDisplay.setProjectsDisabled(newVal);
    }

    /**
     * Disable/enable the menu button in the popup display
     * @param newVal {boolean}
     * @private
     */
    _setMenuDisabled(newVal) {
        this._popupDisplay.setMenuDisabled(newVal);
    }

    /**
     * Update the active organization
     * @param newVal {object}
     * @private
     */
    _setActiveOrganization(newVal) {
        if (!_.isUndefined(newVal)) {
            this._organizationDropdown.setValue(newVal);
            // this._organizationSeparator.innerHTML = this._organizationSeparatorChar;
            //this._popupDisplay.setActiveOrganization(newVal);
            //this._organizationLabel.innerHTML = _.get(newVal, "name", "");
            //if (_.isEmpty(this._organizationLabel.innerHTML)) {
            //    this._organizationSeparator.innerHTML = "";
            //}
            //else {
            //    this._organizationSeparator.innerHTML = this._organizationSeparatorChar;
            //}
            //this._appSolutionsSwitcher.refresh();
        }
    }

    _setActiveProject(newVal) {
        this._popupDisplay.setActiveProject(newVal);
    }

    /**
     * Toggle the disabled state
     * @param newVal {boolean}
     * @private
     */
    _setDisabled(newVal) {
        if (newVal === true) {
            this._rootElem.classList.add("disabled");
        } else {
            this._rootElem.classList.remove("disabled");
        }
    }

    /**
     * Set or remove focus
     * @param newVal {boolean}
     * @private
     */
    _setFocus(newVal) {
        if (newVal === true) {
            this._rootElem.focus();
        } else {
            this._rootElem.blur();
            this._hidePopupWidgets();
        }
    }

    /**
     * hide the popup widgets
     */
    _hidePopupWidgets() {
        if (this._popUpWidget) {
            this._popUpWidget.hide();
        }
        if (this._popUpGridWidget) {
            this._popUpGridWidget.hide();
        }
    }

    _onHideGrid() {
        this._gridIcon.hide();
    }

    /**
     * Create a timeout to hide the homebar
     * @private
     */
    _createHideTimeout(event) {
        if (!_.isUndefined(this._autoHideTimeout)) {
            clearTimeout(this._autoHideTimeout);
        }
        this._autoHideTimeout = setTimeout(() => {
            this._autoHideTimeout = undefined;
            this._model.setShown(false);
            this._model._triggerAutoHide(event);
            this._popUpWidget.hide();
        }, this._autoHideDuration);
    }

    _onVerticalMenuMouseOut(e) {
        if (!(e.toElement && e.toElement.classList.contains("second-step-bgd--expanded"))) {
            this.hideVerticalNavbar();
        }
    }

    _onSecondLevelMenuMouseOut(e) {
        if (!(e.toElement && this.verticalMenuContainer.contains(e.toElement))) {
            this.hideVerticalNavbar();
        }
    }
    /**
     *
     * This method is used to build a new
     * Vertical Navigation
     */
    _buildVerticalMenu() {
        this._xDomeBasedNavItem = [];
        if (this.verticalMenuContainer) {
            this.verticalMenuContainer.innerHTML = "";
        } else {
            this.verticalMenuContainer = document.createElement("div");
            this.verticalMenuContainer.classList.add("vertical-menu-container");
            this.verticalMenuContainer.classList.add("noshadow");
            this.verticalMenuContainer.addEventListener(
                "click",
                (this._onVerticalMenuClick = this._onVerticalMenuClick.bind(this))
            );
            this.verticalMenuContainer.addEventListener(
                "mouseleave",
                (this._onVerticalMenuMouseOut = this._onVerticalMenuMouseOut.bind(this))
            );
        }

        this._secondLevelBackground = document.createElement("div");
        this._secondLevelBackground.classList.add("glu-navigation-second-step-bgd");
        this._secondLevelBackground.addEventListener(
            "mouseleave",
            (this._onSecondLevelMenuMouseOut = this._onSecondLevelMenuMouseOut.bind(this))
        );
        /* Create the Vertical Menu Structure - Start */

        const allSolutions = Object.assign(..._.values(this._model._solutionManager._allSolutions));
        if (!_.isEmpty(allSolutions)) {
            if (_.isEmpty(this._model._sortOrderArray)) {
                this._solutionsSorted = _.sortBy(
                    Object.assign(..._.values(this._model._solutionManager._allSolutions)),
                    "registeredObj.order"
                );
            } else {
                this._solutionsSorted = _.values(
                    Object.assign(..._.values(this._model._solutionManager._allSolutions))
                );
                this._solutionsSorted.sort(this.sorter.bind(this));
            }
            let setExpanded = false;
            this._sortOrderTemp = [];
            this._solutionsSorted.forEach((solution, i) => {
                this._moreLessIndex =
                    this._moreLessIndex &&
                    (this._moreLessIndex.value || this._moreLessIndex.value === 0)
                        ? this._moreLessIndex.value
                        : this._moreLessIndex || this._moreLessIndex === 0
                        ? this._moreLessIndex
                        : 5;
                if (i === this._moreLessIndex) {
                    this.verticalMenuContainer.appendChild(this._createMoreItem());
                }
                this.verticalMenuContainer.appendChild(this._createNavItem(solution, i));
                if (
                    this._model._solutionManager._activeSolution &&
                    solution.registeredObj.name ===
                        this._model._solutionManager._activeSolution.name &&
                    i >= this._moreLessIndex
                ) {
                    setExpanded = true;
                }
            });
            this.verticalMenuContainer.appendChild(this._createHelpItem());

            if (!setExpanded) {
                this._setMoreOrLess(0);
            } else {
                this._setMoreOrLess(1);
            }

            if (_.isEmpty(this._model._sortOrderArray)) {
                const isClassic =
                    _.get(this._model._solutionManager, "_activeSolution.name", "") === "classic";
                if (isClassic && Steve.user) {
                    Steve.user.preferences._regStorage.setValue(
                        "common.vertical_navigation.sort_order",
                        this._sortOrderTemp
                    );
                    Steve.user.preferences._regStorage.setValue(
                        "common.vertical_navigation.more_less_index",
                        5
                    );
                } else if (this._model._userDataStorage && this._model._userDataStorage.setData) {
                    this._model._userDataStorage.setData(this._sortOrderTemp, "sort_order");
                    this._model._userDataStorage.setData(5, "more_less_index");
                }
            }
        }

        /* Create the Vertical Menu Structure - End */
        this._makeNavSortable();

        this._rootElem.appendChild(this.verticalMenuContainer);
        this._rootElem.appendChild(this._secondLevelBackground);

        // Update second-level nav item permissions after menu is built
        this._updateSecondLevelNavPermissions();

        if (this._LicenseRefreshed) {
            this._onLicenseRefresh();
        }

        this._callItOnceMore();
    }

    /**
     *
     * Create First level Nav Items
     */
    _createNavItem(solutionObj, index) {
        // Top Container
        const navItemContainer = this._createMainContainer(solutionObj.registeredObj.name, index);

        if (solutionObj.registeredObj.name === "version_control") {
            navItemContainer.hidden = !this._model._showVersionControl;
            this._versionControlNavItem = navItemContainer;
        }

        navItemContainer.setAttribute("disabled", true);
        if (index >= this._moreLessIndex) {
            navItemContainer.classList.add("to-be-hidden");
        }

        if (
            this._model._solutionManager._activeSolution &&
            solutionObj.registeredObj.name === this._model._solutionManager._activeSolution.name
        ) {
            navItemContainer.classList.add("selected");
        } else if (_.isNull(this._model._solutionManager._activeSolution)) {
            if (
                _.isFunction(this._steveRouter.getRouteDetails) &&
                solutionObj.registeredObj.section === this._steveRouter.getRouteDetails().s
            ) {
                navItemContainer.classList.add("selected");
            }
        }

        if (solutionObj.registeredObj.name === "system_settings") {
            navItemContainer.classList.remove("to-be-hidden");
            navItemContainer.classList.add("nomove");
            navItemContainer.classList.add("bottom");
        }

        if (_.isEmpty(this._model._sortOrderArray)) {
            this._sortOrderTemp.push(solutionObj.registeredObj.name);
        }
        navItemContainer.addEventListener(
            "click",
            (this._onNavItemClick = this._onNavItemClick.bind(this)),
            true
        );
        navItemContainer.addEventListener(
            "mouseover",
            (this._onNavItemHover = this._onNavItemHover.bind(this)),
            true
        );

        // Icon Container
        const navIconContainer = document.createElement("div");
        navIconContainer.classList.add("glu-nav__item-icon");

        // Icon
        const navIconContElem = document.createElement("icon-container-gl"),
            navIcon = document.createElement("base-icon-gl");
        navIcon.dataset.icon = solutionObj.registeredObj.navIcon;

        navIconContElem.appendChild(navIcon);
        navIconContainer.appendChild(navIconContElem);
        if (solutionObj.registeredObj.name === "version_control") {
            const navIconVersionControlCount = document.createElement("span");
            navIconVersionControlCount.classList.add("version-control-count");
            navIconContainer.appendChild(navIconVersionControlCount);
        }

        // Name Section
        const navItemName = document.createElement("div");
        navItemName.classList.add("glu-nav__item-text");

        // Name element
        const name = document.createElement("p");
        name.innerText = solutionObj.registeredObj.label;

        navItemName.appendChild(name);

        if (solutionObj.registeredObj.name === "version_control") {
            this._navTextVersionControlCount = document.createElement("span");
            this._navTextVersionControlCount.classList.add("version-control-count");
            navItemName.appendChild(this._navTextVersionControlCount);
        }

        navItemContainer.appendChild(navIconContainer);
        navItemContainer.appendChild(navItemName);

        if (!_.isEmpty(solutionObj.registeredObj.navOptions)) {
            navItemName.classList.add("deep");
            const chevronIcon = document.createElement("div");
            chevronIcon.classList.add("glu-icon-button", "nav-icon-active");
            chevronIcon.innerText = "";
            navItemName.appendChild(chevronIcon);

            const secondLevelMenu = document.createElement("div");
            secondLevelMenu.classList.add("glu-sub-nav", "false");

            Object.keys(solutionObj.registeredObj.navOptions).forEach((item) => {
                if (
                    solutionObj.registeredObj.navOptions[item].checkPref === true &&
                    this._model[`_${solutionObj.registeredObj.navOptions[item].pref}`] === false
                ) {
                    return;
                }

                const secondLevelItem = this._createSecondLevelNavItem(
                    item,
                    solutionObj.registeredObj.navOptions[item].name,
                    true
                );

                if (item === "iot_device" || item === "iotOsPlans" || item === "odmOsPlatform") {
                    secondLevelItem.hidden = !this._model._showXDomeMenuItems;
                    this._xDomeBasedNavItem.push(secondLevelItem);
                }

                secondLevelMenu.appendChild(secondLevelItem);
                secondLevelItem.addEventListener(
                    "click",
                    (this._onSecondLevelItemClick = this._onSecondLevelItemClick.bind(this)),
                    true
                );
            });

            navItemContainer.appendChild(secondLevelMenu);
        }

        return navItemContainer;
    }

    _addClassIfVersionControlCountExists() {
        if (this._model._versionControlCount > 0) {
            this._versionControlNavItem.classList.add("version-control-count-exists");
            this._updateVersionControlCount();
        } else {
            this._versionControlNavItem.classList.remove("version-control-count-exists");
        }
    }

    _updateVersionControlCount() {
        if (this._navTextVersionControlCount && this._model._versionControlCount > 0) {
            this._navTextVersionControlCount.innerText = `${
                this._model._versionControlCount > 9 ? "9+" : this._model._versionControlCount
            }`;
        }
    }

    /**
     *
     * Create Second level Nav Items
     */
    _createSecondLevelNavItem(item, name, disabled = true) {
        const secondLevelItem = document.createElement("div");
        secondLevelItem.classList.add("glu-sub-nav__item");
        secondLevelItem.innerText = name;
        if (disabled) {
            secondLevelItem.setAttribute("name", "disabled");
        } else {
            secondLevelItem.setAttribute("name", item);
        }
        // TODO: Replace item attribute with name and add a proper disable attribute
        secondLevelItem.setAttribute("item", item);

        return secondLevelItem;
    }

    /**
     *
     * Open link in new tab
     */
    _openInNewTab(href) {
        Object.assign(document.createElement("a"), {
            target: "_blank",
            href: href,
        }).click();
    }

    /**
     * Method to set more or less
     */
    _setMoreOrLess(state = 0) {
        if (this.moreLessIcon.getAttribute("disabled") !== true) {
            if (state) {
                this.moreLessIcon.classList.add("less");
                this.moreLessIcon.classList.remove("more");

                this.verticalMenuContainer.querySelectorAll(".hidden").forEach((hiddenItem) => {
                    hiddenItem.classList.add("to-be-hidden");
                    hiddenItem.classList.remove("hidden");
                });
                this.verticalMenuContainer.querySelector(".more-text").classList.add("hide");
                this.verticalMenuContainer.querySelector(".less-text").classList.remove("hide");
            } else {
                this.moreLessIcon.classList.add("more");
                this.moreLessIcon.classList.remove("less");

                this.verticalMenuContainer
                    .querySelectorAll(".to-be-hidden")
                    .forEach((hiddenItem) => {
                        hiddenItem.classList.remove("to-be-hidden");
                        hiddenItem.classList.add("hidden");
                    });
                this.verticalMenuContainer.querySelector(".more-text").classList.remove("hide");
                this.verticalMenuContainer.querySelector(".less-text").classList.add("hide");
            }
        }
    }

    /**
     * Create More Item
     */
    _createMoreItem() {
        // Top Container
        const navItemContainer = this._createMainContainer();
        navItemContainer.classList.add("nomove");
        navItemContainer.classList.add("ml-item");

        // navItemContainer.addEventListener('mouseenter', this._onNavMoreLessItemHover = this._onNavMoreLessItemHover.bind(this));
        navItemContainer.addEventListener(
            "click",
            (this._onNavMoreLessItemClick = this._onNavMoreLessItemClick.bind(this))
        );

        const moreLessContainer = document.createElement("div");
        moreLessContainer.classList.add(
            "glu-nav__item-icon",
            "less-more-icon",
            "other-items-hidden"
        );

        const moreLessInner = document.createElement("div");
        moreLessInner.classList.add("more-less-icon-inner-container");

        this.moreLessIcon = document.createElement("div");
        this.moreLessIcon.classList.add("more-icon", "more");
        moreLessInner.appendChild(this.moreLessIcon);

        const moreLabel = document.createElement("div");
        moreLabel.classList.add("glu-nav__item-text", "more-less-text", "more-text", "deep");
        moreLabel.innerHTML = "<p>More</p>";

        const LessLabel = document.createElement("div");
        LessLabel.classList.add(
            "glu-nav__item-text",
            "more-less-text",
            "less-text",
            "deep",
            "hide"
        );
        LessLabel.innerHTML = "<p>Less</p>";

        moreLessContainer.appendChild(moreLessInner);

        navItemContainer.appendChild(moreLessContainer);
        navItemContainer.appendChild(moreLabel);
        navItemContainer.appendChild(LessLabel);

        navItemContainer.addEventListener(
            "mouseover",
            (this._onNavItemHover = this._onNavItemHover.bind(this)),
            true
        );

        return navItemContainer;
    }

    _makeNavSortable() {
        Sortable.create(this.verticalMenuContainer, {
            filter: ".nomove",
            onEnd: (/**Event*/ evt) => {
                // const itemEl = evt.item;  // dragged HTMLElement
                this._model._sortOrderArray = [];

                evt.to.querySelectorAll(".glu-nav__item:not(.ml-item)").forEach((item, index) => {
                    item.setAttribute("index", index);
                    this._model._sortOrderArray.push(item.getAttribute("name"));
                    if (index < 5) {
                        item.classList.remove("to-be-hidden");
                    } else if (!item.classList.contains("bottom")) {
                        item.classList.add("to-be-hidden");
                    }
                });

                this._solutionsSorted.sort(this.sorter.bind(this));

                const navItems = [...evt.to.querySelectorAll(".glu-nav__item:not(.bottom)")];
                this._moreLessIndex = navItems.indexOf(
                    evt.to.querySelector(".glu-nav__item.ml-item")
                );

                const isClassic =
                    _.get(this._model._solutionManager, "_activeSolution.name", "") === "classic";
                if (isClassic && Steve.user) {
                    Steve.user.preferences._regStorage.setValue(
                        "common.vertical_navigation.sort_order",
                        this._model._sortOrderArray
                    );
                    Steve.user.preferences._regStorage.setValue(
                        "common.vertical_navigation.more_less_index",
                        this._moreLessIndex
                    );
                } else if (this._model._userDataStorage.setData) {
                    this._model._userDataStorage.setData(this._model._sortOrderArray, "sort_order");
                    this._model._userDataStorage.setData(this._moreLessIndex, "more_less_index");
                }

                navItems.forEach((elem, index) => {
                    if (index < this._moreLessIndex) {
                        elem.classList.remove("to-be-hidden");
                    } else if (index > this._moreLessIndex) {
                        elem.classList.add("to-be-hidden");
                    }
                });

                if (navItems.length - 1 === this._moreLessIndex || this._moreLessIndex === 0) {
                    // navItems[this._moreLessIndex].classList.add("disabled-item");
                    navItems[this._moreLessIndex].setAttribute("disabled", true);
                } else {
                    // navItems[this._moreLessIndex].classList.remove("disabled-item");
                    navItems[this._moreLessIndex].removeAttribute("disabled");
                }

                // if(evt.to.querySelectorAll('.glu-nav__item').item(4).classList.contains('ml-item')) {
                //     evt.to.querySelectorAll('.glu-nav__item').item(5).classList.remove("to-be-hidden");
                //     // evt.to.querySelectorAll('.glu-nav__item').item(4).parentElement.insertBefore(evt.to.querySelectorAll('.glu-nav__item').item(5), evt.to.querySelectorAll('.glu-nav__item').item(4));
                // }

                // if(evt.to.querySelectorAll('.glu-nav__item').item(6).classList.contains('ml-item')) {
                //     evt.to.querySelectorAll('.glu-nav__item').item(5).classList.add("to-be-hidden");
                //     // evt.to.querySelectorAll('.glu-nav__item').item(6).parentElement.insertBefore(evt.to.querySelectorAll('.glu-nav__item').item(6), evt.to.querySelectorAll('.glu-nav__item').item(5));
                // }
            },
        });
    }

    sorter(a, b) {
        return (
            this._model._sortOrderArray.indexOf(a.registeredObj.name) -
            this._model._sortOrderArray.indexOf(b.registeredObj.name)
        );
    }

    _createHelpItem() {
        this.helpIconContainer = this._createMainContainer();
        this.helpIconContainer.classList.add("nomove");
        this.helpIconContainer.classList.add("bottom");
        this.helpIconContainer.classList.add("bottom--no-mt");
        this.helpIconContainer.classList.add("help-icon");

        //initialize link
        const helpLink = _.get(this._model, "_solutionManager._activeSolution.helpLink", false);
        if (helpLink) {
            this.helpIconContainer.setAttribute("help-link", helpLink);
        }

        // Icon Container
        const navIconContainer = document.createElement("div");
        navIconContainer.classList.add("glu-nav__item-icon");

        // Icon
        const navIconContElem = document.createElement("icon-container-gl"),
            navIcon = document.createElement("base-icon-gl");
        navIcon.dataset.icon = "help.solution";
        navIconContElem.appendChild(navIcon);
        navIconContainer.appendChild(navIconContElem);

        // Name Section
        const navItemName = document.createElement("div");
        navItemName.classList.add("glu-nav__item-text");

        // Name element
        const name = document.createElement("p");
        name.innerText = "Help";
        navItemName.appendChild(name);

        this.helpIconContainer.appendChild(navIconContainer);
        this.helpIconContainer.appendChild(navItemName);

        this.helpIconContainer.addEventListener(
            "mouseover",
            (this._onNavItemHover = this._onNavItemHover.bind(this)),
            true
        );
        this.helpIconContainer.addEventListener(
            "click",
            (this._onHelpIconClick = this._onHelpIconClick.bind(this)),
            true
        );

        return this.helpIconContainer;
    }

    _createMainContainer(solutionName = false, index = false) {
        const navItemContainer = document.createElement("div");
        navItemContainer.classList.add("glu-nav__item");
        if (index) {
            navItemContainer.setAttribute("index", index);
        }
        if (solutionName) {
            navItemContainer.setAttribute("name", solutionName);
        }
        navItemContainer.setAttribute("draggable", false);
        return navItemContainer;
    }

    _toggleHideFirstLevelClass(state = false) {
        if (state) {
            document
                .querySelectorAll(".glu-nav__item-text")
                .forEach((eachItem) => eachItem.classList.add("noshow"));
            this._secondLevelBackground.classList.add("noshow");
        } else {
            document
                .querySelectorAll(".glu-nav__item-text")
                .forEach((eachItem) => eachItem.classList.remove("noshow"));
            this._secondLevelBackground.classList.remove("noshow");
        }
    }

    _toggleTheme(state = true) {
        if (state) {
            document.body.setAttribute("themed", "glu-themed--light");
        } else {
            document.body.setAttribute("themed", "glu-themed--dark");
        }
    }

    _toggleShowUnlicensed(state = true) {
        this.verticalMenuContainer
            .querySelectorAll(".glu-nav__item[disabled]")
            .forEach((disabledItem) => {
                if (state === false) {
                    disabledItem.classList.add("unlicensed");
                } else {
                    disabledItem.classList.remove("unlicensed");
                }
            });
    }

    _hideFirstLevel() {
        document
            .querySelectorAll(".glu-nav__item-text")
            .forEach((eachItem) => eachItem.classList.remove("expanded"));
        document
            .querySelectorAll(".glu-nav__item")
            .forEach((eachItem) => eachItem.classList.remove("hover"));
    }

    _hideSecondLevel() {
        this.verticalMenuContainer.classList.remove("noshadow");
        this._secondLevelBackground.classList.remove("second-step-bgd--expanded");
        this.verticalMenuContainer
            .querySelectorAll(".glu-sub-nav")
            .forEach((eachNavItem) => eachNavItem.classList.remove("second-step--expanded"));
    }

    hideVerticalNavbar() {
        const openNav = this.verticalMenuContainer.querySelectorAll(".expanded");
        if (openNav.length > 0) {
            this._hideFirstLevel();
            this._hideSecondLevel();
            this.verticalMenuContainer.classList.add("noshadow");
        }
    }

    _callItOnceMore() {
        const _callItDebounced = _.debounce(this._onLicenseRefresh.bind(this), 100);
        _callItDebounced();
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = HomeBarRenderer;
